import { PRIVATE_MODULES_PATH } from "./root.path";

const BASE = PRIVATE_MODULES_PATH.MORTGAGE_REFERENCE;
const _ = (...arg: any[]) => `/${BASE}/${arg.join("/")}`;

// create path router
const ROUTER = {
  ROOT: "",
  CREATE: "create",
  LIST: "list",
  DETAIL: "detail",
  DETAIL_V3: "detail/:id/v3",
  EDIT: "detail/:id/edit"
};

// create path routes
const PATH = {
  ROOT: `/${BASE}`,
  CREATE: `/${BASE}/${ROUTER.CREATE}`,
  DETAIL: (ID: number | string) => `/${BASE}/${ROUTER.DETAIL}/${ID}`,
  DETAIL_V3: (ID: number | string) => `/${BASE}/${ROUTER.DETAIL}/${ID}/v3`,
  LIST: `/${BASE}/${ROUTER.LIST}`,
  EDIT: (ID: number | string) => `/${BASE}/${ROUTER.DETAIL}/${ID}/edit`
};

// export
const MORTGAGE_PATH = {
  ROUTES: PATH,
  ROUTER
};

export default MORTGAGE_PATH;
